import React from 'react';
const stats = [{
  value: '+500',
  label: 'entrenadores confían',
  icon: '👥'
}, {
  value: '6+6',
  label: 'Tomos + Bonos',
  icon: '📚'
}, {
  value: '4.9/5',
  label: 'calificación',
  icon: '⭐'
}, {
  value: '🌎',
  label: 'Mercado hispano',
  icon: ''
}];
const testimonials = [{
  initials: 'JR',
  quote: 'Organicé todo el año en una tarde. Nunca más llegué al campo sin saber qué trabajar ni cómo corregir a los niños.',
  name: 'José R.',
  location: 'Ciudad de México',
  role: 'Entrenador de academia barrial'
}, {
  initials: 'MG',
  quote: 'Las planillas de evaluación me cambiaron la relación con los padres. Ahora les muestro evidencia real del progreso de cada jugador cada mes.',
  name: 'Marcela G.',
  location: 'Buenos Aires',
  role: 'Coordinadora técnica'
}, {
  initials: 'CP',
  quote: 'El sistema de sesiones por edad es único. Mis jugadores de U12 ahora entienden el juego de una forma que antes me llevaba una temporada completa lograr.',
  name: 'Carlos P.',
  location: 'Bogotá',
  role: 'Entrenador independiente U10–U14'
}];
export function SocialProofBar() {
  return <section className="w-full py-14 px-4 relative overflow-hidden" style={{
    background: 'linear-gradient(180deg, #052e16 0%, #020617 100%)'
  }} data-id="element-250">
      {/* Subtle ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[200px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(ellipse, rgba(34,197,94,0.05) 0%, transparent 70%)'
    }} data-id="element-251" />

      <div className="relative max-w-5xl mx-auto" data-id="element-252">
        {/* Stats row */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6 mb-12" data-id="element-253">
          {stats.map(stat => <div key={stat.label} className="relative text-center py-4 px-2 rounded-xl bg-black/30 border border-[#22C55E]/10" data-id="element-254">
              <div className="text-3xl sm:text-4xl md:text-5xl font-black text-white leading-none mb-1.5" data-id="element-255">
                {stat.value}
              </div>
              <div className="text-[#22C55E] text-xs sm:text-sm font-semibold tracking-wide uppercase" data-id="element-256">
                {stat.icon && <span className="mr-1" data-id="element-257">{stat.icon}</span>}
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* Divider */}
        <div className="w-20 h-[2px] bg-gradient-to-r from-transparent via-[#22C55E]/40 to-transparent mx-auto mb-10" data-id="element-258" />

        {/* Testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-259">
          {testimonials.map(t => <div key={t.initials} className="group relative bg-black/50 border border-[#22C55E]/15 rounded-2xl p-5 transition-colors hover:border-[#22C55E]/30" data-id="element-260">
              {/* Quote mark */}
              <div className="absolute top-3 right-4 text-[#22C55E]/10 text-4xl font-serif leading-none pointer-events-none" data-id="element-261">
                "
              </div>

              <div className="flex items-center gap-3 mb-3" data-id="element-262">
                <div className="w-9 h-9 rounded-full bg-[#22C55E]/15 border border-[#22C55E]/25 flex items-center justify-center text-[#22C55E] font-bold text-xs flex-shrink-0" data-id="element-263">
                  {t.initials}
                </div>
                <div data-id="element-264">
                  <div className="text-white font-bold text-sm leading-tight" data-id="element-265">
                    {t.name}
                  </div>
                  <div className="text-gray-500 text-[11px]" data-id="element-266">
                    📍 {t.location} · {t.role}
                  </div>
                </div>
              </div>

              <p className="text-gray-300 text-sm leading-relaxed mb-2" data-id="element-267">
                "{t.quote}"
              </p>

              <div className="text-[#22C55E]/60 text-[10px] tracking-wider" data-id="element-268">
                ⭐⭐⭐⭐⭐
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}